/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Card, Typography, Box, CardContent, Grid, CardMedia,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import BuildIcon from '@material-ui/icons/Build';
import ErrorIcon from '@material-ui/icons/Error';
import SvgIcon from '@material-ui/core/SvgIcon';
import useSWR from 'swr';
import axios from 'axios';
import { ReactComponent as ScanIcon } from '../../assets/icons/scan.svg';

interface RepairCardProps {
  barcode: string,
  error?: boolean,
  iconType?: 'repair' | 'barcode',
  primaryText?: string,
  secondaryText?: string,
}

const RepairCard: React.FC<RepairCardProps> = ({
  barcode = 'Missing Number', error, iconType = 'barcode', primaryText = 'Current Repair', secondaryText = 'Barcode Number',
}) => {
  const imageFetcher = (url: string, repairBarcodeParam: string) => axios.get<{ photoUrls:string[] }>(url, {
    params: {
      repairBarcode: repairBarcodeParam,
      thumbnails: true,
    },
  }).then((res) => res.data);

  const { data: images } = useSWR(barcode ? ['/MetalCollection/GetRepairImages', barcode] : null, (url, repairBarcodeParam) => imageFetcher(url, repairBarcodeParam));

  return (
    <Card style={{ height: '100%' }}>
      <CardContent style={{ padding: 0 }}>
        <Grid container alignItems="stretch" spacing={0}>
          <Grid item xs={6}>
            <Box p={2}>
              <Box pl={2}>
                { (iconType === 'repair')
                  ? <BuildIcon />
                  : <SvgIcon fontSize="large" component={ScanIcon} />}
                <Typography variant="h6">
                  {primaryText}
                </Typography>
              </Box>
              <CardContent>
                <Typography variant="h4">
                  {`${barcode} `}
                  {error && <ErrorIcon style={{ color: 'red', marginBottom: '0.20em' }} />}
                </Typography>
                <Typography color="textSecondary">
                  {secondaryText}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
          <Grid item zeroMinWidth xs={6}>
            { images
              ? (
                images.photoUrls.length > 0
                  ? (
                    <Box ml={3} clone>
                      <CardMedia
                        component="img"
                        image={images?.photoUrls?.[0]}
                        style={{
                          objectFit: 'scale-down',
                          height: '100%',
                          top: 'auto',
                        }}
                      />
                    </Box>
                  )

                  : (
                    <Box
                      ml={2}
                      style={{ maxWidth: '100%', height: '100%', backgroundColor: 'gray' }}
                    >
                      {'No Image Available'}
                    </Box>
                  )
              )
              : (
                <Skeleton>
                  <Box ml={3} clone>
                    <CardMedia
                      component="img"
                      image=""
                      style={{
                        objectFit: 'scale-down',
                        height: '100%',
                        top: 'auto',
                      }}
                    />
                  </Box>
                </Skeleton>
              )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RepairCard;
